document.addEventListener("alpine:init", () => {
    Alpine.data("EcocreditsForm", () => ({
      loading: false,
      step: 1,
      agreeToMarketing: false,
      email: "",
      answer: "",
      stepOneEmailErrMsg: "",
      stepOneDisclaimerErrMsg: "",
      stepTwoErrMsg: "",
      showSuccessCopyMessage: false,
      answerSelected: [],

      // Functions
      setStep(step) {
        this.step = step;
      },

      // Save email to alpine and pass to next step
      async submitStepOneEmail() {
        const isEmailValid = validateEmail(this.email);
        if (!isEmailValid) {
          this.stepOneEmailErrMsg = "Please enter a valid email address.";
          return;
        } else if (!this.agreeToMarketing) {
          this.stepOneDisclaimerErrMsg = "Please tick agreement boxes to proceed.";
          return;
        }

        // If no error, remove error message
        this.stepOneErrMsg = "";

        // getContactListId function in subscription-form-common.js
        const contactListId = getContactListId(EcocreditsVoteNWinFormSettingJsons);

        // Extract theme global variables from theme.liquid
        const { apiUrl, acceptedLanguage, apiKey, xAppid } =
          theme.emailSubscription;

        const subscribeInfoCookie = window.getCookieForEmarsys('subscribe_info');
        let eventTracking = null;

        if (subscribeInfoCookie) {
          try {
            const decodedCookie = decodeURIComponent(subscribeInfoCookie)
            eventTracking = JSON.parse(decodedCookie);
            delete eventTracking.ts
            console.log('eventTracking', eventTracking);
          } catch (error) {
            console.log('eventTracking error', subscribeInfoCookie);
            console.warn('Failed to parse subscribe_info cookie:', error);
          }
        };

        const apiBody = {
          email: this.email,
          contactListId,
          fields: [
            {
              // Country field id: EU = 4427
              id: "4427",
              type: "single",
              value: 1,
              overwrite: true,
            },
            {
              id: "31",
              type: "single",
              value: 1,
              overwrite: true,
            },
            {
              id: "5910",
              type: "single",
              value: 1,
              overwrite: true,
            },
            {
              id: "7596",
              type: "multiple",
              value: [58],
              overwrite: false,
            },
          ],
          ...(eventTracking && { eventTracking }),
        };
        this.loading = true;
        try {
          const response = await fetch(
            // Header global settings are defined in star-email-subscription-form.liquid
            // Except traceId is defined in subscription-form-common.js
            apiUrl,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                apiKey: apiKey,
                traceId: traceId,
                "X-appid": xAppid,
                "Accepted-Language": acceptedLanguage,
              },
              body: JSON.stringify(apiBody),
            }
          );

          const data = await response.json();

          if (data.message === "Success") {
            this.setStep(2);
          }
        } catch (error) {
          this.stepTwoErrMsg =
            "Oops... Something went wrong, please refresh and try again.";
        } finally {
          this.loading = false;
        }
      },
      async submitResult() {
        this.stepTwoErrMsg = "";
        // Checking for empty answer
        document.querySelectorAll(".ecocredits-vote-form__step-2-answer").forEach(item => {
          if (item.querySelector("input:checked")) {
            this.answerSelected.push(parseInt(item.querySelector("input:checked").value));
          }
        });
        if (this.step === 2 && this.answerSelected.length === 0) {
          this.stepTwoErrMsg = "Please select an answer";
          return;
        }

        // getContactListId function in subscription-form-common.js
        const contactListId = getContactListId(EcocreditsVoteNWinFormSettingJsons);

        // Extract theme global variables from theme.liquid
        const { apiUrl, acceptedLanguage, apiKey, xAppid } =
          theme.emailSubscription;

        const subscribeInfoCookie = window.getCookieForEmarsys('subscribe_info');
        let eventTracking = null;

        if (subscribeInfoCookie) {
          try {
            const decodedCookie = decodeURIComponent(subscribeInfoCookie)
            eventTracking = JSON.parse(decodedCookie);
            delete eventTracking.ts
            console.log('eventTracking', eventTracking);
          } catch (error) {
            console.log('eventTracking error', subscribeInfoCookie);
            console.warn('Failed to parse subscribe_info cookie:', error);
          }
        };

        const apiBody = {
          email: this.email,
          contactListId,
          fields: [
            {
              id: "13836",
              type: "multiple",
              value: this.answerSelected,
              overwrite: true,
            },
          ],
          ...(eventTracking && { eventTracking }),
        };

        this.loading = true;

        try {
          const response = await fetch(
            // Header global settings are defined in star-email-subscription-form.liquid
            // Except traceId is defined in subscription-form-common.js
            apiUrl,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                apiKey: apiKey,
                traceId: traceId,
                "X-appid": xAppid,
                "Accepted-Language": acceptedLanguage,
              },
              body: JSON.stringify(apiBody),
            }
          );

          const data = await response.json();

          if (data.message === "Success") {
            this.setStep(3);
          }
        } catch (error) {
          this.stepTwoErrMsg =
            "Oops... Something went wrong, please refresh and try again.";
        } finally {
          this.loading = false;
        }
      },
      // Copy discount code to clipboard
      copyCodeToClipboard(couponCode) {
        navigator.clipboard.writeText(couponCode);
        this.showSuccessCopyMessage = true;
      },
    }));
  });
